<template>
  <div class="settings">
    <v-card flat="flat" class="nuclear" v-if="profile.role == 4">
      <v-card-title class="nuclear-title"
        >Configuration / Settings</v-card-title
      >
      <v-card-text class="nuclear-content">
        <span>This feature is not available for View Only User</span>
      </v-card-text>
    </v-card>
    <v-card flat="flat" class="nuclear" v-else>
      <v-card-title class="nuclear-title"
        >Configuration / Settings</v-card-title
      >
      <v-card-text class="nuclear-content">
        <v-container class="report_setting">
          <div class="report_title">
            <p>Send report automatically</p>
            <i>(All Future Uploaded Reports Will Be Shared)</i>
          </div>
          <v-row justify="space-between">
            <v-col cols="12" md="3" sm="6" class="setting_switch">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="setting_group.switch_on"
                  @change="changeSwitch"
                />
                <span class="slider round"></span>
              </label>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="setting_email">
              <v-form ref="form">
                <v-checkbox
                  label="My system e-mail"
                  v-model="setting_group.mysystem_email_check"
                  color="#2bb9aa"
                  :disabled="!setting_group.switch_on"
                ></v-checkbox>
              </v-form>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-form ref="form">
                <v-checkbox
                  label="Custom e-mail"
                  v-model="setting_group.custom_email_check"
                  color="#2bb9aa"
                  :disabled="!setting_group.switch_on"
                ></v-checkbox>
                <v-text-field
                  label="Email"
                  type="text"
                  v-model="setting_group.custom_email"
                  :rules="emailRule"
                  required
                  :disabled="
                    !setting_group.custom_email_check ||
                      !setting_group.switch_on
                  "
                ></v-text-field>
              </v-form>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-form ref="form">
                <v-checkbox
                  label="Custom group"
                  v-model="setting_group.custom_group_check"
                  color="#2bb9aa"
                  :disabled="!setting_group.switch_on"
                ></v-checkbox>
                <v-text-field
                  label="Emails"
                  type="text"
                  v-model="setting_group.group_emails"
                  required
                  :disabled="
                    !setting_group.custom_group_check ||
                      !setting_group.switch_on
                  "
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
          <!-- <p class="manage">
                        <router-link to="/managegroup">
                            manage groups
                        </router-link>
                    </p> -->
        </v-container>
        <v-container class="control_panel">
          <v-row justify="space-between">
            <!-- <v-col cols="12" md="6" class="include">
                            <v-card flat="flat" class="card">
                                <v-card-title>Include in Report</v-card-title>
                                <v-card-text>
                                    <v-checkbox :label="item.label" color="#2bb9aa" v-for="item in includeitems" :key="item.id" v-model="item.value"></v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-col> -->
            <v-col cols="12" md="12" class="ignore">
              <v-card flat="flat" class="card">
                <v-card-title>
                  <span>Ignore these findings</span>
                  <v-icon color="teal lighten-2" class="info-icon">mdi-information</v-icon>
                  <div class="future-scan-label">
                    <span >This will only be applied to future scans.</span>
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-checkbox
                    :label="item.label"
                    color="#2bb9aa"
                    v-for="item in ignoreitems"
                    :key="item.id"
                    v-model="item.value"
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="footer">
        <v-btn class="commit" color="#2bb9aa" @click="SendSettings"
          >COMMIT</v-btn
        >
        <v-btn class="discard" color="white" @click="Initialize">UNCHECK ALL</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      includeitems: [
        { id: 1, label: "Full Name", value: false },
        { id: 2, label: "Email", value: false },
        { id: 3, label: "Option 1", value: false },
        { id: 4, label: "Option 2", value: false },
        { id: 5, label: "Option 3", value: false },
        { id: 6, label: "Option 4", value: false },
        { id: 7, label: "Option 5", value: false },
        { id: 8, label: "Option 6", value: false },
        { id: 9, label: "Option 7", value: false },
        { id: 10, label: "Option 8", value: false },
        { id: 11, label: "Option 9", value: false },
        { id: 12, label: "Option 10", value: false },
        { id: 13, label: "Option 11", value: false },
        { id: 14, label: "Option 12", value: false },
        { id: 15, label: "Option 13", value: false },
        { id: 16, label: "Option 14", value: false },
        { id: 17, label: "Option 15", value: false }
      ],
      emailRule: [
        v => !!v || "Email is required",
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Invalid e-mail.";
        }
      ],
      custom_group_email: "",
      dialog: false
    };
  },
  mounted() {
    this.$store.dispatch("getAllFindings");
    this.$store.dispatch("aboutMe");
    this.$store.dispatch("getSettings");
  },
  computed: {
    ignoreitems() {
      return this.$store.state.findings.all;
    },
    register_email() {
      return this.$store.getters.register_email;
    },
    super_admin_id() {
      return this.$store.getters.super_admin_id;
    },
    setting_group() {
      return this.$store.state.setting.setting_group;
    },
    profile() {
      return this.$store.state.user.profile;
    },
  },
  methods: {
    Initialize() {
      this.includeitems.map(item => (item.value = false));
      this.ignoreitems.map(item => (item.value = false));
    },
    changeSwitch() {
      if (this.setting_group.switch_on == false) {
        this.setting_group.mysystem_email_check = false;
        this.setting_group.custom_email_check = false;
        this.setting_group.custom_email = "";
        this.setting_group.custom_group_check = false;
        this.setting_group.custom_groups = [];
      } else {
        this.setting_group.mysystem_email_check = true;
        this.setting_group.custom_email_check = true;
        this.setting_group.custom_group_check = true;
      }
    },
    SendSettings() {
      this.setting_group.switch_on =
        this.setting_group.switch_on == true ? 1 : 0;
      this.setting_group.mysystem_email_check =
        this.setting_group.mysystem_email_check == true ? 1 : 0;
      this.setting_group.custom_email_check =
        this.setting_group.custom_email_check == true ? 1 : 0;
      this.setting_group.custom_group_check =
        this.setting_group.custom_group_check == true ? 1 : 0;

      let findings = this.ignoreitems.map(item => ({
        id: item.id,
        ignore: item.value
      }));

      this.$store.dispatch("updateSettings", this.setting_group);
      this.$store.dispatch("updateFindings", findings);
    },
    addEmail() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.custom_groups.push(this.custom_group_email);
      //this.custom_group_email = '';
    },
    createGroup() {
      if (!this.$refs.form.validate()) {
        return;
      }
      // console.log(this.custom_group_email);
      // this.custom_groups.push(this.custom_group_email);
      console.log(this.custom_groups);
      console.log(this.super_admin_id);
    }
  }
};
</script>
